import { useTranslation } from "react-i18next";
import { Search, Plus } from "lucide-react";
import { NeuButton, NeuInput } from "../../components/neu/Neu";

// شريط أدوات القيود: بحث + زر قيد جديد.
export const JournalToolbar = ({ query, setQuery, canPost, onNew }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="journal-toolbar">
      {canPost ? (
        <NeuButton variant="primary" className="flex items-center gap-2"
                   data-testid="entry-add-btn" onClick={onNew}>
          <Plus className="h-4 w-4" /> {t("acct.newEntry")}
        </NeuButton>
      ) : null}
      <div className="relative flex-1 min-w-[240px]">
        <Search className="pointer-events-none absolute top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground
                            end-3 rtl:start-3 rtl:end-auto" />
        <NeuInput data-testid="journal-search" value={query}
                  placeholder={t("acct.journal.searchPlaceholder")}
                  onChange={(e) => setQuery(e.target.value)}
                  className="px-10" />
      </div>
    </div>
  );
};
